"use client";

import React, { ReactNode } from "react";
import { LoadingIcon } from "./icons";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

interface LoadMoreProps {
  total: number;
  totalCurrent: number;
  onLoadMore: () => void;
  type?: "infinity" | "click";
  children?: ReactNode;
  loading?: boolean;
  className?: string;
}
export default function LoadMore({
  loading,
  totalCurrent,
  onLoadMore,
  total,
  type = "click",
  children,
  className,
}: LoadMoreProps) {
  const { t } = useTranslationApi(["load_more"]);

  return (
    <div className={className}>
      {children}
      {loading ? (
        <LoadingIcon />
      ) : (
        type === "click" &&
        totalCurrent < total && (
          <p className="font-bold cursor-pointer" onClick={onLoadMore}>
            {t("load_more")}
          </p>
        )
      )}
    </div>
  );
}
